import receiptInstance from './instance'

const getReceipt = (companyIndex, orderPublicId) => {
	return receiptInstance.get(`/${companyIndex}/receipts/${orderPublicId}`)
}

export default getReceipt
